import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import {
  clearRestoreData,
  handleRestoreRoute,
  handleRestoreRouteFailed,
  restoreAccountEmail,
  restoreAccountPassword,
} from 'redux/actions/restoreAccountActions';
import FinishRecovery from './PasswordRecovery/FinishRecovery';
import Loading from 'shared/ui/Loading';
import Login from './Login';
import NewPassword from './PasswordRecovery/NewPassword';
import Registration from './Registration';
import { RootState } from 'types/stateTypes';
import StartRecovery from './PasswordRecovery/StartRecovery';
import { useAppSelector } from 'hooks/hooks';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Auth = (): JSX.Element => {
  const location = useLocation();
  const navigation = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const loading = useAppSelector((state: RootState) => state.restoreAccount.loading);
  const error = useAppSelector((state: RootState) => state.restoreAccount.errorText);
  const metaData = useAppSelector((state: RootState) => state.restoreAccount.metaData);
  const finish = useAppSelector((state: RootState) => state.restoreAccount.success);
  const isMailSent = useAppSelector((state: RootState) => state.restoreAccount.isMailSent);
  const mailSentMessage = isMailSent ? t('auth.check.your.mail') : '';

  const handleSubmitEmail = (email: string) => dispatch(restoreAccountEmail(email));
  const handleSubmitNewPassword = (password: string) => dispatch(restoreAccountPassword({ ...metaData, password }));

  const backToRoot = () => {
    dispatch(clearRestoreData());
    navigation.push('/');
  };

  useEffect(() => {
    if (location.pathname === '/login-actions/reset-credentials') {
      const params = location.search;
      if (params.includes('key=')) {
        dispatch(handleRestoreRoute(params));
      } else {
        console.error('empty key error');
        dispatch(handleRestoreRouteFailed({ message: 'empty key error' }));
      }
    }
  }, [location, dispatch]);

  const startPage = () => <StartRecovery handleSubmit={handleSubmitEmail} error={mailSentMessage || error} />;
  const newPasswordPage = () => <NewPassword handleSubmit={handleSubmitNewPassword} error={t(error)} />;
  const finishPage = () => <FinishRecovery handleSubmit={backToRoot} />;

  const resetPage = finish ? finishPage : newPasswordPage;

  return (
    <Switch>
      <Route path={'/login'} component={Login} />
      <Route path={'/registration'} component={Registration} />
      <Route path={'/restore-password'} component={startPage} />
      <Route path={'/login-actions/reset-credentials'} component={loading ? Loading : resetPage} />
      <Route path={'/login-actions/verify-email'} component={Login} />
      <Redirect from="/" to={'/login'} />
    </Switch>
  );
};
export default Auth;
